const t={sm:0,md:768,lg:1024,xl:1440,"nav-tablet":1140};export{t as responsiveBreakpointsPx};
